import React, { memo } from "react";

/**
 * Footer component with React.memo for performance
 * Following React performance best practices
 */
const Footer = memo(function Footer(): React.ReactElement {
    return (
        <footer className="bg-gray-50 border-t mt-auto dark:bg-gray-900 dark:border-gray-800">
            <div className="max-w-6xl mx-auto px-4 py-6">
                <p className="text-center text-gray-500 text-sm dark:text-gray-400">
          &copy; {new Date().getFullYear()} React Boilerplate. Built with Vite, React & TypeScript.
                </p>
            </div>
        </footer>
    );
});

export default Footer;
